import { inject, Injectable } from '@angular/core';
import { ApiService, LocalStorageService, User } from '@us/web/shared/data-access';
import { nanoid } from 'nanoid';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OtpProvider } from '../enums';
import { GetAccessTokenResponse, LoginParams, LoginResponse, UpdateProfileParams } from '../models';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly apiService = inject(ApiService);
    private readonly deviceService = inject(DeviceDetectorService);
    private readonly localStorage = inject(LocalStorageService);

    verifyPhoneNumber(params: { phoneNumber: string }) {
        return this.apiService.post<{
            account_exist: boolean;
            pin_code_exist: boolean;
        }>('verify-phone-number', params);
    }

    login(params: LoginParams) {
        return this.apiService.post<LoginResponse>(`login`, { ...params });
    }

    getLocalAccountId(forceRefresh = false): string {
        let localAccountId = this.localStorage.getItem('local_account_id');
        if (forceRefresh || !localAccountId) {
            localAccountId = nanoid();
            this.localStorage.setItem('local_account_id', localAccountId);
        }

        return localAccountId;
    }

    getAccessToken(forceRefresh = false) {
        const params = {
            client_id: 'mnRZ6u9DWm',
            client_secret: 'HdhClxkTjFyV295PfGH9AgHKv86MOyeZ',
            local_account_id: this.getLocalAccountId(forceRefresh)
        };
        return this.apiService.post<GetAccessTokenResponse>('partner/oauth2/token', { ...params });
    }

    sendOtp(params: { phone_number: string }) {
        return this.apiService.post<{
            otp_provider: OtpProvider;
            expire_in: number;
        }>('send-otp', params);
    }

    verifyOtp(params: { phone_number: string; otp: string; otp_provider: OtpProvider; reset_pin_code?: boolean }) {
        return this.apiService.post<LoginResponse>('verify-otp', { ...params });
    }

    updateProfile(params: UpdateProfileParams): Observable<{ user: User; token: GetAccessTokenResponse }> {
        return this.apiService.patch<LoginResponse>('account', { ...params }).pipe(
            map(response => {
                const { access_token, token_type, expires_in, api_domain, ...user } = response;
                return {
                    user,
                    token: { access_token, token_type, expires_in, api_domain }
                };
            })
        );
    }

    // verifyFirebaseIdToken(accessToken: string) {
    //     return this.apiService.post<LoginResponse>('auth/firebase/verify-token', { accessToken });
    // }
    //
    // memberRegister(params: MemberRegisterParams) {
    //     return this.apiService.post('member-register', { ...params });
    // }

    // register(params: RegisterParams) {
    //     return this.apiService.post<LoginResponse>(this.registerUrl, params);
    // }

    // registerPushNotification(token: string, accountId: number | string) {
    //     const params = {
    //         token,
    //         account_id: accountId,
    //         details: this.deviceService.getDeviceInfo()
    //     };
    //
    //     return this.apiService.post(this.pushNotificationUrl, params);
    // }
}
